// Settings for the hosted app.

/** Free API key from the National Land Survey of Finland (Maanmittauslaitos). With it the app gets the detailed
 *  Finnish topographic map, which can also be saved for offline use. Leave empty to run without it. */
export const MML_API_KEY = "0ba15cce-1d00-4975-8e7d-72612e64daa9";

/** Public half of the push notification key pair (the private half is a Cloudflare secret, VAPID_PRIVATE_KEY). */
export const VAPID_PUBLIC_KEY = "BJaHWRyL58mOtCQ8f0BRWqwTNW8RZAZZ-NWenrTMrEOmifScO_w6cC8IvogL8IatOwV8zt0FqjtKKNB-TT6MNz8";

/* ---------- ReelHunt Plus and the club plan (billing.ts; setup steps in store/BILLING-SETUP.md) ---------- */
/** RevenueCat public keys. While the Test Store key is set, the app uses the Test Store (no money moves): empty it
 *  before the store release. The app's code comes from the website, so a deploy changes these for every installed app. */
export const REVENUECAT_TEST_KEY = "test_NrQbJGikYSvIlQqrSndesatfPdM";
export const REVENUECAT_ANDROID_KEY = "";
export const REVENUECAT_IOS_KEY = "";
/** The website shows Plus bought in the app to signed-in users (buying is only in the store apps). Turn on when
 *  the store products are live; until then the website has everything unlocked. */
export const BILLING_ON_WEB = false;
/** RevenueCat offering ids: "founding" (1,99 €/19,99 €) is the current offering while founding members sign up,
 *  then "standard" (2,99 €/24,99 €). The club plan (39,99 €/year) is the offering "club". */
export const FOUNDING_OFFERING = "founding";
export const CLUB_OFFERING = "club";
/** Groups can use the stand board with this many stands without the club plan. */
export const FREE_STANDS = 3;
export const PRIVACY_URL = "/privacy/";
export const TERMS_URL = "/terms/";

/** The club area from Oma riista (groups/clubarea.ts). Until the production credentials come, the server talks to Oma
 *  riista's test environment, so the "show the club area" link stays hidden: open the app once with ?omariista=1
 *  (or on localhost) to see it. Set true when the server uses production. */
export const OMARIISTA_OPEN = false;
